import { AppPricesRepository, FlexiblePromotionsRepository } from '../repositories';

let processedAppPrices = [];
const observableProcessedAppPrices = new Rx.BehaviorSubject(processedAppPrices);

/**
* @ngdoc service
* @name processors.AppPricesProcessor
*
* @description
* This class is used to process app prices.
*/
const AppPricesProcessor = {

    onNextAppPrices(data) {

        processedAppPrices = data;

    },

    onNextPromotions(data) {


        processedAppPrices = [...AppPricesRepository.getAll()];

        if (processedAppPrices.length > 0) {

            processedAppPrices.forEach((appPrice) => {

                const currentPromotion =
                    data.find(promotion => promotion.price_id === appPrice.id);

                if (currentPromotion && currentPromotion.attributes.discount > 0) {

                    appPrice.attributes.promotion = currentPromotion.attributes;

                }

            });

        }

        observableProcessedAppPrices.onNext(processedAppPrices);

    },

    getAll() {

        return processedAppPrices;

    },

    getSinglePrice(dataId, runtime, devices) {

        return processedAppPrices.find(_appPrice => String(_appPrice.id) === String(`${dataId}_${runtime}_${devices}`));

    },

    getObservable() {

        return observableProcessedAppPrices;

    },

};


const subjectAppPricesRepository = AppPricesRepository.getObservable();
subjectAppPricesRepository.subscribe(
    data => AppPricesProcessor.onNextAppPrices(data),
    () => { },
    () => { },
);

const subjectFlexiblePromotionsRepository = FlexiblePromotionsRepository.getObservable();
subjectFlexiblePromotionsRepository.subscribe(
    data => AppPricesProcessor.onNextPromotions(data),
    () => { },
    () => { },
);

export default AppPricesProcessor;



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/-RFC.appPricesProcessor.js